import pickBy from "lodash/pickBy";
import startsWith from "lodash/startsWith";
import trim from "lodash/trim";
import { decode } from "querystring";

export function pickUTM(object) {
  return pickBy(object, (_v, k) => startsWith(k, "utm_"));
}

export function extractUTM(queryString) {
  const str = trim(queryString, "?");
  if (!str) return {};
  return pickUTM(decode(str));
}
